import { Swiper } from 'swiper/bundle'

const textSlider = document.querySelector('.textSlider')

if (textSlider) {
	// eslint-disable-next-line no-inner-declarations
	function updatePaginationCustom(swiper) {
		const index = swiper.realIndex + 1 // Текущий слайд
		const total = swiper.slides.length // Общее количество слайдов без дублированных в loop режиме
		document.querySelector('.current-slide').textContent = index.toString().padStart(2, '0')
		document.querySelector('.total-slides').textContent = ` / ${total.toString().padStart(2, '0')}`
	}

	const textSliderSwiper = new Swiper('.textSlider', {
		spaceBetween: 48,
		loop: true,
		slidesPerView: 1,
		speed: 600,
		effect: 'fade',
		navigation: {
			nextEl: '.swiper-next',
			prevEl: '.swiper-prev'
		},
		on: {
			init() {
				updatePaginationCustom(this)
			},
			slideChange() {
				updatePaginationCustom(this)
			}
		}
	})
}
